export default __webpack_public_path__ + "static/media/element_spec_51.da13d1e1.webp";